import React from 'react';
import { userProfileRoute } from '../../../../../routes';
import RouteDefinition from '../../../../../helpers/Route/RouteDefinition';

export const userViewRoute = new RouteDefinition({
  path: `${userProfileRoute.path}/view`,
  component: React.lazy(() => import('../../View')),
});

export const userPersonalDataRoute = new RouteDefinition({
  path: `${userProfileRoute.path}/edit/personal-data`,
  component: React.lazy(() => import('../../Edit/PersonalData')),
});

export const userLhcMangerDataRoute = new RouteDefinition({
  path: `${userProfileRoute.path}/edit/lhc-manager-data`,
  component: React.lazy(() => import('../../Edit/LhcManagerData')),
});

export const userFacilityMangerDataRoute = new RouteDefinition({
  path: `${userProfileRoute.path}/edit/facility-manager-data`,
  component: React.lazy(() => import('../../Edit/FacilityManagerData')),
});

export const userGroupDataRoute = new RouteDefinition({
  path: `${userProfileRoute.path}/edit/group-data`,
  component: React.lazy(() => import('../../Edit/GroupData')),
});

export const userEditRoute = new RouteDefinition({
  path: `${userProfileRoute.path}/edit/credentials`,
  component: React.lazy(() => import('../../Edit/Credentials')),
});
